// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"1d307d7e","453":"51d823ef","457":"00e44dab","796":"8105e6a1","851":"55855dc1"}[chunkId] + ".chunk.js";
};